import { AccountAddParams } from '@lk/api/account/models'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accountAdd = createAsyncThunk<any, Partial<AccountAddParams>, ThunkApi>(
  '[ACCOUNT_ADD] ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.add('add', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountEdit = createAsyncThunk<any, Partial<AccountAddParams>, ThunkApi>(
  '[ACCOUNT_ADD] EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.add('edit', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountDelete = createAsyncThunk<any, Partial<AccountAddParams>, ThunkApi>(
  '[ACCOUNT_ADD] DELETE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.add('delete', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountGenaccno = createAsyncThunk<any, Partial<AccountAddParams>, ThunkApi>(
  '[ACCOUNT_ADD] GENACCNO',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.add('genaccno', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
